module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAKtJREFUOE/tVEEKwjAQ3IWmveQgePJVHnyDMV9KLiFP8BlFjwq+QvCWQOhIPSmYNmA9FLrX3Z1lZnaXaeLgEjxr7R5ADaDVWp+HeooAjTEHIhLM3CqlTgvghwIz0dB7vw4h1Dn3mHkLoCKiKxHdcnUxxvuLsrV2B2BTspNDNUKI438AnXMrACI3PaXUM6i6rrs0TdPT/hpSysdMXB4zY7nl39/X5A92zLT3/BNWKHzEnXL53gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/upload-add-icon.png
// module id = 7Krd
// module chunks = 0